// tslint:disable
/**
 * MyGeoAPI
 * My Geo API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccessibleSelections
 */
export interface AccessibleSelections {
    /**
     * 
     * @type {boolean}
     * @memberof AccessibleSelections
     */
    accessible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccessibleSelections
     */
    handicappedParking?: boolean;
}
/**
 * The Address of, for example, a ÖAMTC base
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    county?: string;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    zipCode?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
}
/**
 * A single payment method information, defined by type.
 * @export
 * @interface AuthenticationOption
 */
export interface AuthenticationOption {
    /**
     * 
     * @type {AuthenticationType}
     * @memberof AuthenticationOption
     */
    type?: AuthenticationType;
    /**
     * Payment option is present at entity.
     * @type {boolean}
     * @memberof AuthenticationOption
     */
    isAvailable?: boolean;
    /**
     * Optional comment.
     * @type {Array<Comment>}
     * @memberof AuthenticationOption
     */
    comment?: Array<Comment>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AuthenticationType {
    APP = 'APP',
    NFC = 'NFC',
    RFID = 'RFID',
    SMS = 'SMS',
    WEBSITE = 'WEBSITE',
    OTHER = 'OTHER'
}

/**
 * An ÖAMTC base
 * @export
 * @interface Base
 */
export interface Base {
    /**
     * 
     * @type {Address}
     * @memberof Base
     */
    address?: Address;
    /**
     * 
     * @type {Location}
     * @memberof Base
     */
    location?: Location;
    /**
     * 
     * @type {string}
     * @memberof Base
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Base
     */
    id?: string;
    /**
     * 
     * @type {Array<OpeningHoursDay>}
     * @memberof Base
     */
    openHours?: Array<OpeningHoursDay>;
    /**
     * 
     * @type {Contact}
     * @memberof Base
     */
    contact?: Contact;
    /**
     * 
     * @type {TextBlocks}
     * @memberof Base
     */
    textBlocks?: TextBlocks;
}
/**
 * 
 * @export
 * @interface Bypass
 */
export interface Bypass {
    /**
     * 
     * @type {number}
     * @memberof Bypass
     */
    radius?: number;
}
/**
 * 
 * @export
 * @interface CameraAttributes
 */
export interface CameraAttributes {
    /**
     * 
     * @type {string}
     * @memberof CameraAttributes
     */
    roadId?: string;
}
/**
 * 
 * @export
 * @interface ChangeOemtcBase
 */
export interface ChangeOemtcBase {
    /**
     * 
     * @type {string}
     * @memberof ChangeOemtcBase
     */
    poiId: string;
}
/**
 * 
 * @export
 * @interface ChannelContextEntry
 */
export interface ChannelContextEntry {
    /**
     * 
     * @type {string}
     * @memberof ChannelContextEntry
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChannelContextEntry
     */
    source?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChannelContextEntry
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChannelContextEntry
     */
    query?: string;
}
/**
 * 
 * @export
 * @interface ChargingPoint
 */
export interface ChargingPoint {
    /**
     * 
     * @type {string}
     * @memberof ChargingPoint
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ChargingPoint
     */
    capacityKw?: number;
    /**
     * 
     * @type {CostType}
     * @memberof ChargingPoint
     */
    cost?: CostType;
    /**
     * 
     * @type {Array<PaymentType>}
     * @memberof ChargingPoint
     */
    payments?: Array<PaymentType>;
    /**
     * 
     * @type {Array<PlugType>}
     * @memberof ChargingPoint
     */
    plugs?: Array<PlugType>;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof ChargingPoint
     */
    vehicles?: Array<VehicleType>;
    /**
     * 
     * @type {boolean}
     * @memberof ChargingPoint
     */
    roaming?: boolean;
}
/**
 * A comment, identified by language and mimeType
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * Language of the comment.
     * @type {string}
     * @memberof Comment
     */
    lang?: CommentLangEnum;
    /**
     * Mime-Type of the comment.
     * @type {string}
     * @memberof Comment
     */
    mimetype?: CommentMimetypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    content?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CommentLangEnum {
    GERMAN = 'GERMAN',
    ENGLISH = 'ENGLISH'
}
/**
    * @export
    * @enum {string}
    */
export enum CommentMimetypeEnum {
    Plain = 'text/plain',
    Html = 'text/html'
}

/**
 * Base specific contact information
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    phone?: string;
    /**
     * Link in a html <a>-tag
     * @type {string}
     * @memberof Contact
     */
    web?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    fax?: string;
}
/**
 * 
 * @export
 * @interface ContainerMap
 */
export interface ContainerMap {
    /**
     * 
     * @type {Coordinate}
     * @memberof ContainerMap
     */
    center?: Coordinate;
    /**
     * 
     * @type {string}
     * @memberof ContainerMap
     */
    style?: string;
    /**
     * 
     * @type {number}
     * @memberof ContainerMap
     */
    zoomLevel?: number;
}
/**
 * 
 * @export
 * @interface Coordinate
 */
export interface Coordinate {
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    latitude?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CostType {
    FREE = 'FREE',
    PAID = 'PAID',
    UNKNOWN = 'UNKNOWN'
}

/**
 * Opening hours per day. Maybe a list with multiple slots.
 * @export
 * @interface DailyOpeningHours
 */
export interface DailyOpeningHours {
    /**
     * Opening hours of monday.
     * @type {Array<OpeningHour>}
     * @memberof DailyOpeningHours
     */
    monday?: Array<OpeningHour>;
    /**
     * Opening hours of tuesday.
     * @type {Array<OpeningHour>}
     * @memberof DailyOpeningHours
     */
    tuesday?: Array<OpeningHour>;
    /**
     * Opening hours of wednesday.
     * @type {Array<OpeningHour>}
     * @memberof DailyOpeningHours
     */
    wednesday?: Array<OpeningHour>;
    /**
     * Opening hours of thursday.
     * @type {Array<OpeningHour>}
     * @memberof DailyOpeningHours
     */
    thursday?: Array<OpeningHour>;
    /**
     * Opening hours of friday.
     * @type {Array<OpeningHour>}
     * @memberof DailyOpeningHours
     */
    friday?: Array<OpeningHour>;
    /**
     * Opening hours of saturday.
     * @type {Array<OpeningHour>}
     * @memberof DailyOpeningHours
     */
    saturday?: Array<OpeningHour>;
    /**
     * Opening hours of sunday.
     * @type {Array<OpeningHour>}
     * @memberof DailyOpeningHours
     */
    sunday?: Array<OpeningHour>;
    /**
     * Opening hours of a public holiday, disregarding weekday.
     * @type {Array<OpeningHour>}
     * @memberof DailyOpeningHours
     */
    holiday?: Array<OpeningHour>;
}
/**
 * 
 * @export
 * @interface EfuelAttributes
 */
export interface EfuelAttributes {
    /**
     * 
     * @type {Array<EfuelPriceSeason>}
     * @memberof EfuelAttributes
     */
    prices?: Array<EfuelPriceSeason>;
    /**
     * 
     * @type {Array<ChargingPoint>}
     * @memberof EfuelAttributes
     */
    chargingPoints?: Array<ChargingPoint>;
    /**
     * 
     * @type {EfuelFacilities}
     * @memberof EfuelAttributes
     */
    facilities?: EfuelFacilities;
    /**
     * 
     * @type {boolean}
     * @memberof EfuelAttributes
     */
    greenEnergy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EfuelAttributes
     */
    oeamtcEPowerStation?: boolean;
}
/**
 * 
 * @export
 * @interface EfuelFacilities
 */
export interface EfuelFacilities {
    /**
     * List of authentication method informations
     * @type {Array<AuthenticationOption>}
     * @memberof EfuelFacilities
     */
    authenticationOptions?: Array<AuthenticationOption>;
    /**
     * List of payment method informations.
     * @type {Array<PaymentOption>}
     * @memberof EfuelFacilities
     */
    paymentOptions?: Array<PaymentOption>;
}
/**
 * 
 * @export
 * @interface EfuelPrice
 */
export interface EfuelPrice {
    /**
     * 
     * @type {EfuelSource}
     * @memberof EfuelPrice
     */
    efuelSource?: EfuelSource;
    /**
     * 
     * @type {EfuelPriceUnit}
     * @memberof EfuelPrice
     */
    unit?: EfuelPriceUnit;
    /**
     * 
     * @type {number}
     * @memberof EfuelPrice
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof EfuelPrice
     */
    lastUpdated?: string;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof EfuelPrice
     */
    comment?: Array<Comment>;
}
/**
 * 
 * @export
 * @interface EfuelPriceSeason
 */
export interface EfuelPriceSeason {
    /**
     * 
     * @type {Season}
     * @memberof EfuelPriceSeason
     */
    season?: Season;
    /**
     * 
     * @type {Array<EfuelPrice>}
     * @memberof EfuelPriceSeason
     */
    prices?: Array<EfuelPrice>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EfuelPriceUnit {
    KWH = 'PER_KWH',
    MINUTE = 'PER_MINUTE'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum EfuelSource {
    ECONTROL = 'ECONTROL',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    message?: string;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ErrorResponse
     */
    errors?: Array<Error>;
}
/**
 * 
 * @export
 * @interface Favorite
 */
export interface Favorite {
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Favorite
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof Favorite
     */
    lat?: number;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    tupelId?: string;
    /**
     * 
     * @type {FavoriteType}
     * @memberof Favorite
     */
    type?: FavoriteType;
    /**
     * 
     * @type {FavoriteSubType}
     * @memberof Favorite
     */
    subType?: FavoriteSubType;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    objectId?: string;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    poicat?: string;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    listId?: string;
}
/**
 * 
 * @export
 * @interface FavoriteAttributes
 */
export interface FavoriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof FavoriteAttributes
     */
    listId?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteAttributes
     */
    referenceId?: string;
}
/**
 * Subtype of the favorite (aligned with poi categories)
 * @export
 * @enum {string}
 */
export enum FavoriteSubType {
    CAMPER = 'CAMPER',
    CAMPING = 'CAMPING',
    BASE = 'BASE',
    TRAVELAGENCY = 'TRAVEL_AGENCY',
    CHRISTOPHORUSBASE = 'CHRISTOPHORUS_BASE',
    DRIVINGSKILLSCENTER = 'DRIVING_SKILLS_CENTER',
    BORDERSTATION = 'BORDER_STATION',
    BICYCLESTATION = 'BICYCLE_STATION',
    STATECLUB = 'STATE_CLUB',
    MOBILITYPARK = 'MOBILITY_PARK',
    PARKINGGARAGE = 'PARKING_GARAGE',
    OPENSPACE = 'OPEN_SPACE',
    PARKANDRIDE = 'PARK_AND_RIDE',
    BUSPARKING = 'BUS_PARKING',
    PARKANDDRIVE = 'PARK_AND_DRIVE',
    SERVICESTATION = 'SERVICE_STATION',
    RESTAREA = 'REST_AREA',
    PARKINGAREA = 'PARKING_AREA',
    AIRPORT = 'AIRPORT',
    BUILDING = 'BUILDING',
    ENTERTAINMENT = 'ENTERTAINMENT',
    MUSEUM = 'MUSEUM',
    NATURE = 'NATURE',
    RESTAURANT = 'RESTAURANT',
    SHOPPING = 'SHOPPING',
    TRAINSTATION = 'TRAIN_STATION',
    TOURISTINFORMATION = 'TOURIST_INFORMATION',
    OEAMTCEPOWERSTATION = 'OEAMTC_E_POWERSTATION'
}

/**
 * Type of the favorite (aligned with poi ressources)
 * @export
 * @enum {string}
 */
export enum FavoriteType {
    ADDRESS = 'ADDRESS',
    ACCOMMODATION = 'ACCOMMODATION',
    CAMERA = 'CAMERA',
    CAMPING = 'CAMPING',
    EFUEL = 'EFUEL',
    ENTERTAINMENT = 'ENTERTAINMENT',
    FUEL = 'FUEL',
    GASTRONOMY = 'GASTRONOMY',
    GREENZONE = 'GREENZONE',
    HEALTH = 'HEALTH',
    LEISURE = 'LEISURE',
    MOBILITY = 'MOBILITY',
    OEAMTC = 'OEAMTC',
    PARKING = 'PARKING',
    PASSROAD = 'PASSROAD',
    PUBLICTRANSPORT = 'PUBLICTRANSPORT',
    ROADHOUSE = 'ROADHOUSE',
    SHOPPING = 'SHOPPING',
    SHOTTERMPARKING = 'SHOTTERMPARKING',
    SIGHT = 'SIGHT',
    SPECIALTOLLROAD = 'SPECIALTOLLROAD',
    SPORTS = 'SPORTS',
    TUNNEL = 'TUNNEL'
}

/**
 * 
 * @export
 * @interface FavoritesComputed
 */
export interface FavoritesComputed {
    /**
     * 
     * @type {Array<FavoriteType>}
     * @memberof FavoritesComputed
     */
    types?: Array<FavoriteType>;
}
/**
 * 
 * @export
 * @interface FavoritesList
 */
export interface FavoritesList {
    /**
     * 
     * @type {string}
     * @memberof FavoritesList
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoritesList
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoritesList
     */
    note?: string;
    /**
     * 
     * @type {Array<Favorite>}
     * @memberof FavoritesList
     */
    favorites?: Array<Favorite>;
}
/**
 * 
 * @export
 * @interface FavoritesListEntry
 */
export interface FavoritesListEntry {
    /**
     * 
     * @type {Array<GeoFavorite>}
     * @memberof FavoritesListEntry
     */
    favorites?: Array<GeoFavorite>;
    /**
     * 
     * @type {string}
     * @memberof FavoritesListEntry
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoritesListEntry
     */
    gis2Id?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoritesListEntry
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoritesListEntry
     */
    note?: string;
}
/**
 * 
 * @export
 * @interface FavoritesListResponse
 */
export interface FavoritesListResponse {
    /**
     * 
     * @type {Array<FavoritesListEntry>}
     * @memberof FavoritesListResponse
     */
    lists?: Array<FavoritesListEntry>;
    /**
     * 
     * @type {FavoritesComputed}
     * @memberof FavoritesListResponse
     */
    computed?: FavoritesComputed;
}
/**
 * 
 * @export
 * @interface FuelAttributes
 */
export interface FuelAttributes {
    /**
     * 
     * @type {Array<FuelPriceSeason>}
     * @memberof FuelAttributes
     */
    prices?: Array<FuelPriceSeason>;
}
/**
 * 
 * @export
 * @interface FuelPrice
 */
export interface FuelPrice {
    /**
     * 
     * @type {FuelType}
     * @memberof FuelPrice
     */
    fuel?: FuelType;
    /**
     * 
     * @type {FuelSource}
     * @memberof FuelPrice
     */
    fuelSource?: FuelSource;
    /**
     * 
     * @type {FuelPriceUnit}
     * @memberof FuelPrice
     */
    unit?: FuelPriceUnit;
    /**
     * 
     * @type {number}
     * @memberof FuelPrice
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof FuelPrice
     */
    lastUpdated?: string;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof FuelPrice
     */
    comment?: Array<Comment>;
}
/**
 * 
 * @export
 * @interface FuelPriceSeason
 */
export interface FuelPriceSeason {
    /**
     * 
     * @type {Season}
     * @memberof FuelPriceSeason
     */
    season?: Season;
    /**
     * 
     * @type {Array<FuelPrice>}
     * @memberof FuelPriceSeason
     */
    prices?: Array<FuelPrice>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FuelPriceUnit {
    PERLITER = 'PER_LITER'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum FuelSource {
    ECONTROL = 'ECONTROL',
    OTHER = 'OTHER',
    OEAMTC = 'OEAMTC'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum FuelType {
    GASOLINE = 'GASOLINE',
    GASOLINESUPER = 'GASOLINE_SUPER',
    GASOLINESUPERPLUS = 'GASOLINE_SUPER_PLUS',
    GASOLINEPREMIUM = 'GASOLINE_PREMIUM',
    DIESEL = 'DIESEL',
    DIESELPREMIUM = 'DIESEL_PREMIUM',
    BIODIESEL = 'BIODIESEL',
    HYDROGEN = 'HYDROGEN',
    NATURALGAS = 'NATURAL_GAS',
    AUTOGAS = 'AUTOGAS',
    ADBLUE = 'ADBLUE',
    HVO100 = 'HVO100',
    UNKNOWN = 'UNKNOWN'
}

/**
 * 
 * @export
 * @interface GeoFavorite
 */
export interface GeoFavorite {
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    gis2Id?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof GeoFavorite
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoFavorite
     */
    lat?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    tupelId?: string;
    /**
     * 
     * @type {FavoriteType}
     * @memberof GeoFavorite
     */
    type?: FavoriteType;
    /**
     * 
     * @type {FavoriteSubType}
     * @memberof GeoFavorite
     */
    subType?: FavoriteSubType;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    objectId?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    poicat?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    listId?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    reference?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFavorite
     */
    referenceType?: string;
}
/**
 * 
 * @export
 * @interface GeoLocation
 */
export interface GeoLocation {
    /**
     * 
     * @type {number}
     * @memberof GeoLocation
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoLocation
     */
    lat?: number;
}
/**
 * 
 * @export
 * @interface GeoObject
 */
export interface GeoObject {
    /**
     * 
     * @type {string}
     * @memberof GeoObject
     */
    type: string;
    /**
     * 
     * @type {Array<Coordinate>}
     * @memberof GeoObject
     */
    coordinates?: Array<Coordinate>;
}
/**
 * 
 * @export
 * @interface Geographic
 */
export interface Geographic {
    /**
     * 
     * @type {string}
     * @memberof Geographic
     */
    type: string;
}
/**
 * 
 * @export
 * @interface GeographicBoundingBoxSelection
 */
export interface GeographicBoundingBoxSelection {
    /**
     * 
     * @type {number}
     * @memberof GeographicBoundingBoxSelection
     */
    longitudeMin: number;
    /**
     * 
     * @type {number}
     * @memberof GeographicBoundingBoxSelection
     */
    longitudeMax: number;
    /**
     * 
     * @type {number}
     * @memberof GeographicBoundingBoxSelection
     */
    latitudeMin: number;
    /**
     * 
     * @type {number}
     * @memberof GeographicBoundingBoxSelection
     */
    latitudeMax: number;
}
/**
 * 
 * @export
 * @interface GeographicCircleSelection
 */
export interface GeographicCircleSelection {
    /**
     * 
     * @type {number}
     * @memberof GeographicCircleSelection
     */
    centerLongitude: number;
    /**
     * 
     * @type {number}
     * @memberof GeographicCircleSelection
     */
    centerLatitude: number;
    /**
     * 
     * @type {number}
     * @memberof GeographicCircleSelection
     */
    radius: number;
}
/**
 * 
 * @export
 * @interface GeographicCorridorSelection
 */
export interface GeographicCorridorSelection {
    /**
     * 
     * @type {string}
     * @memberof GeographicCorridorSelection
     */
    polylineWKT: string;
    /**
     * 
     * @type {number}
     * @memberof GeographicCorridorSelection
     */
    radius: number;
}
/**
 * 
 * @export
 * @interface GeographicSelections
 */
export interface GeographicSelections {
    /**
     * 
     * @type {GeographicBoundingBoxSelection}
     * @memberof GeographicSelections
     */
    boundingBox?: GeographicBoundingBoxSelection;
    /**
     * 
     * @type {GeographicCircleSelection}
     * @memberof GeographicSelections
     */
    circle?: GeographicCircleSelection;
    /**
     * 
     * @type {GeographicCorridorSelection}
     * @memberof GeographicSelections
     */
    corridor?: GeographicCorridorSelection;
}
/**
 * 
 * @export
 * @interface IdResponse
 */
export interface IdResponse {
    /**
     * 
     * @type {string}
     * @memberof IdResponse
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface IdsSelections
 */
export interface IdsSelections {
    /**
     * 
     * @type {Array<string>}
     * @memberof IdsSelections
     */
    list?: Array<string>;
}
/**
 * 
 * @export
 * @interface InfoLayer
 */
export interface InfoLayer {
    /**
     * 
     * @type {Array<object>}
     * @memberof InfoLayer
     */
    filters?: Array<object>;
    /**
     * 
     * @type {Geographic}
     * @memberof InfoLayer
     */
    geographic?: Geographic;
}
/**
 * 
 * @export
 * @interface Linestring
 */
export interface Linestring {
    /**
     * 
     * @type {string}
     * @memberof Linestring
     */
    format?: string;
    /**
     * 
     * @type {string}
     * @memberof Linestring
     */
    data?: string;
}
/**
 * Latitude and Longitude of the POI
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    lng?: number;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    region?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MeanOfTransport {
    PUBLIC = 'PUBLIC',
    CAR = 'CAR',
    MOTORCYCLE = 'MOTORCYCLE',
    CAMPER = 'CAMPER',
    TRAILER = 'TRAILER',
    BIKE = 'BIKE',
    FOOT = 'FOOT',
    BIKEANDRIDE = 'BIKE_AND_RIDE',
    CARRIAGEOFBIKE = 'CARRIAGE_OF_BIKE',
    PARKANDRIDE = 'PARK_AND_RIDE',
    KISSANDRIDE = 'KISS_AND_RIDE',
    CARTRAIN = 'CAR_TRAIN',
    BIKESHARING = 'BIKE_SHARING',
    SHARING = 'SHARING'
}

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface MultiError
 */
export interface MultiError {
    /**
     * 
     * @type {MultiResultItemType}
     * @memberof MultiError
     */
    resource?: MultiResultItemType;
    /**
     * 
     * @type {string}
     * @memberof MultiError
     */
    type?: MultiErrorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MultiError
     */
    message?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MultiErrorTypeEnum {
    TIMEOUT = 'TIMEOUT',
    APIERROR = 'API_ERROR',
    SERVERERROR = 'SERVER_ERROR'
}

/**
 * 
 * @export
 * @interface MultiResultItem
 */
export interface MultiResultItem {
    /**
     * 
     * @type {MultiResultItemType}
     * @memberof MultiResultItem
     */
    type?: MultiResultItemType;
    /**
     * ID in source API
     * @type {string}
     * @memberof MultiResultItem
     */
    id?: string;
    /**
     * Displayable Name
     * @type {string}
     * @memberof MultiResultItem
     */
    name?: string;
    /**
     * Geographic longitude
     * @type {number}
     * @memberof MultiResultItem
     */
    longitude?: number;
    /**
     * Geographic latitude
     * @type {number}
     * @memberof MultiResultItem
     */
    latitude?: number;
    /**
     * Address street
     * @type {string}
     * @memberof MultiResultItem
     */
    street?: string;
    /**
     * Address house number
     * @type {string}
     * @memberof MultiResultItem
     */
    houseNumber?: string;
    /**
     * Address postal code
     * @type {string}
     * @memberof MultiResultItem
     */
    postalCode?: string;
    /**
     * Address city
     * @type {string}
     * @memberof MultiResultItem
     */
    city?: string;
    /**
     * Address country
     * @type {string}
     * @memberof MultiResultItem
     */
    country?: string;
    /**
     * Distance to user coordinates if provided in request
     * @type {number}
     * @memberof MultiResultItem
     */
    distance?: number;
    /**
     * 
     * @type {OpeningInformation}
     * @memberof MultiResultItem
     */
    openingInformation?: OpeningInformation;
    /**
     * 
     * @type {PartnerInformation}
     * @memberof MultiResultItem
     */
    partnerInformation?: PartnerInformation;
    /**
     * 
     * @type {SpecificAttributes}
     * @memberof MultiResultItem
     */
    typeSpecificAttributes?: SpecificAttributes;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MultiResultItemType {
    ADDRESS = 'ADDRESS',
    ACCOMMODATION = 'ACCOMMODATION',
    CAMERA = 'CAMERA',
    CAMPING = 'CAMPING',
    EFUEL = 'EFUEL',
    ENTERTAINMENT = 'ENTERTAINMENT',
    FUEL = 'FUEL',
    GASTRONOMY = 'GASTRONOMY',
    GREENZONE = 'GREENZONE',
    HEALTH = 'HEALTH',
    LEISURE = 'LEISURE',
    MOBILITY = 'MOBILITY',
    OEAMTC = 'OEAMTC',
    PARKING = 'PARKING',
    PASSROAD = 'PASSROAD',
    PUBLICTRANSPORT = 'PUBLICTRANSPORT',
    ROADHOUSE = 'ROADHOUSE',
    SIGHT = 'SIGHT',
    SHOPPING = 'SHOPPING',
    SHORTTERMPARKING = 'SHORTTERMPARKING',
    SPECIALTOLLROAD = 'SPECIALTOLLROAD',
    SPORTS = 'SPORTS',
    TRAFFIC = 'TRAFFIC',
    TRAFFICPREDICTION = 'TRAFFIC_PREDICTION',
    TUNNEL = 'TUNNEL'
}

/**
 * 
 * @export
 * @interface MultiResultList
 */
export interface MultiResultList {
    /**
     * 
     * @type {MultiResultListHeader}
     * @memberof MultiResultList
     */
    header?: MultiResultListHeader;
    /**
     * 
     * @type {Array<MultiResultItem>}
     * @memberof MultiResultList
     */
    results?: Array<MultiResultItem>;
    /**
     * 
     * @type {Array<MultiError>}
     * @memberof MultiResultList
     */
    errors?: Array<MultiError>;
}
/**
 * 
 * @export
 * @interface MultiResultListHeader
 */
export interface MultiResultListHeader {
    /**
     * 
     * @type {string}
     * @memberof MultiResultListHeader
     */
    etag?: string;
    /**
     * 
     * @type {number}
     * @memberof MultiResultListHeader
     */
    start: number;
    /**
     * 
     * @type {number}
     * @memberof MultiResultListHeader
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof MultiResultListHeader
     */
    totalCount: number;
    /**
     * 
     * @type {string}
     * @memberof MultiResultListHeader
     */
    sortField?: string;
    /**
     * 
     * @type {string}
     * @memberof MultiResultListHeader
     */
    sortOrder?: string;
}
/**
 * 
 * @export
 * @interface MultiSelections
 */
export interface MultiSelections {
    /**
     * 
     * @type {GeographicSelections}
     * @memberof MultiSelections
     */
    geographic?: GeographicSelections;
    /**
     * 
     * @type {Array<MultiResultItemType>}
     * @memberof MultiSelections
     */
    type?: Array<MultiResultItemType>;
    /**
     * 
     * @type {RoadClassSelections}
     * @memberof MultiSelections
     */
    roadClass?: RoadClassSelections;
    /**
     * 
     * @type {PriceSelections}
     * @memberof MultiSelections
     */
    price?: PriceSelections;
    /**
     * 
     * @type {SelectionValueList}
     * @memberof MultiSelections
     */
    category?: SelectionValueList;
    /**
     * 
     * @type {SelectionValueList}
     * @memberof MultiSelections
     */
    operator?: SelectionValueList;
    /**
     * 
     * @type {OpeningHoursSelections}
     * @memberof MultiSelections
     */
    openingHours?: OpeningHoursSelections;
    /**
     * 
     * @type {TimeSelections}
     * @memberof MultiSelections
     */
    time?: TimeSelections;
    /**
     * 
     * @type {AccessibleSelections}
     * @memberof MultiSelections
     */
    accessible?: AccessibleSelections;
    /**
     * 
     * @type {RatingsSelections}
     * @memberof MultiSelections
     */
    ratings?: RatingsSelections;
    /**
     * 
     * @type {IdsSelections}
     * @memberof MultiSelections
     */
    ids?: IdsSelections;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiSelections
     */
    favoriteListIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface OeamtcAttributes
 */
export interface OeamtcAttributes {
    /**
     * 
     * @type {Array<string>}
     * @memberof OeamtcAttributes
     */
    categories?: Array<string>;
}
/**
 * Single opening hour range, without break inbetween.
 * @export
 * @interface OpeningHour
 */
export interface OpeningHour {
    /**
     * 
     * @type {string}
     * @memberof OpeningHour
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHour
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface OpeningHoursDay
 */
export interface OpeningHoursDay {
    /**
     * 
     * @type {string}
     * @memberof OpeningHoursDay
     */
    day?: string;
    /**
     * 
     * @type {Array<TimeFrame>}
     * @memberof OpeningHoursDay
     */
    timeFrames?: Array<TimeFrame>;
}
/**
 * Opening hours filter by service.
 * @export
 * @interface OpeningHoursSelections
 */
export interface OpeningHoursSelections {
    /**
     * Specific service that opening hours are connected to.
     * @type {string}
     * @memberof OpeningHoursSelections
     */
    title?: string;
    /**
     * Return only items open now and 1h in future.
     * @type {boolean}
     * @memberof OpeningHoursSelections
     */
    openNextHour?: boolean;
    /**
     * Return only items that are open allday.
     * @type {boolean}
     * @memberof OpeningHoursSelections
     */
    openAllDay?: boolean;
    /**
     * 
     * @type {TimeRangeSelection}
     * @memberof OpeningHoursSelections
     */
    openHours?: TimeRangeSelection;
}
/**
 * Opening information
 * @export
 * @interface OpeningInformation
 */
export interface OpeningInformation {
    /**
     * 
     * @type {boolean}
     * @memberof OpeningInformation
     */
    openAllDay?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OpeningInformation
     */
    openNextHour?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OpeningInformation
     */
    minutesLeftOpen?: number;
    /**
     * 
     * @type {number}
     * @memberof OpeningInformation
     */
    minutesLeftClosed?: number;
}
/**
 * 
 * @export
 * @interface ParkingAttributes
 */
export interface ParkingAttributes {
    /**
     * 
     * @type {Array<string>}
     * @memberof ParkingAttributes
     */
    categories?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ParkingAttributes
     */
    pricePerDay?: number;
    /**
     * 
     * @type {number}
     * @memberof ParkingAttributes
     */
    pricePerHour?: number;
    /**
     * 
     * @type {number}
     * @memberof ParkingAttributes
     */
    pricePerMonth?: number;
    /**
     * 
     * @type {ParkingUtilization}
     * @memberof ParkingAttributes
     */
    utilization?: ParkingUtilization;
}
/**
 * 
 * @export
 * @interface ParkingUtilization
 */
export interface ParkingUtilization {
    /**
     * 
     * @type {string}
     * @memberof ParkingUtilization
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof ParkingUtilization
     */
    source?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParkingUtilization
     */
    dataAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParkingUtilization
     */
    state?: ParkingUtilizationStateEnum;
    /**
     * 
     * @type {number}
     * @memberof ParkingUtilization
     */
    maxParkingLots?: number;
    /**
     * 
     * @type {number}
     * @memberof ParkingUtilization
     */
    freeParkingLots?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ParkingUtilization
     */
    hasFreeParkingLots?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum ParkingUtilizationStateEnum {
    FREE = 'FREE',
    OCCUPIED = 'OCCUPIED',
    UNKNOWN = 'UNKNOWN'
}

/**
 * Partner information
 * @export
 * @interface PartnerInformation
 */
export interface PartnerInformation {
    /**
     * 
     * @type {boolean}
     * @memberof PartnerInformation
     */
    oeamtcPartner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerInformation
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface PassroadAttributes
 */
export interface PassroadAttributes {
    /**
     * 
     * @type {string}
     * @memberof PassroadAttributes
     */
    roadId?: string;
    /**
     * 
     * @type {string}
     * @memberof PassroadAttributes
     */
    roadName?: string;
    /**
     * 
     * @type {string}
     * @memberof PassroadAttributes
     */
    fromTo?: string;
    /**
     * 
     * @type {string}
     * @memberof PassroadAttributes
     */
    lcID?: string;
}
/**
 * A single payment method information, defined by type.
 * @export
 * @interface PaymentOption
 */
export interface PaymentOption {
    /**
     * 
     * @type {PaymentType}
     * @memberof PaymentOption
     */
    type?: PaymentType;
    /**
     * Payment option is present at entity.
     * @type {boolean}
     * @memberof PaymentOption
     */
    isAvailable?: boolean;
    /**
     * Optional comment.
     * @type {Array<Comment>}
     * @memberof PaymentOption
     */
    comment?: Array<Comment>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PaymentType {
    CASHBAR = 'CASH_BAR',
    BANKOMAT = 'BANKOMAT',
    MAESTRO = 'MAESTRO',
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD',
    AMERICANEXPRESS = 'AMERICAN_EXPRESS',
    DINERSCLUB = 'DINERS_CLUB',
    CREDITCARD = 'CREDIT_CARD',
    OTHER = 'OTHER',
    DIRECTPAYMENT = 'DIRECT_PAYMENT'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PlugType {
    SCHUKOPLUG = 'SCHUKO_PLUG',
    TYP1 = 'TYP1',
    TYP2 = 'TYP2',
    TYP3 = 'TYP3',
    CCSTYP1 = 'CCS_TYP1',
    CCSTYP2 = 'CCS_TYP2',
    CHADEMO = 'CHA_DE_MO',
    CEETHREEPOLE = 'CEE_THREE_POLE',
    CEEFIVEPOLE = 'CEE_FIVE_POLE',
    TESLA = 'TESLA',
    IEC603092RED32A = 'IEC_60309-2_RED_32A',
    UNKNOWN = 'UNKNOWN'
}

/**
 * A short representation for a POI i.e. an Öamtc stützpunkt
 * @export
 * @interface Poi
 */
export interface Poi {
    /**
     * 
     * @type {Address}
     * @memberof Poi
     */
    address?: Address;
    /**
     * 
     * @type {Location}
     * @memberof Poi
     */
    location?: Location;
    /**
     * 
     * @type {string}
     * @memberof Poi
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Poi
     */
    id?: string;
    /**
     * The type of POI i.e. Stützpunkt or Reisebüro
     * @type {string}
     * @memberof Poi
     */
    category?: string;
}
/**
 * 
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * 
     * @type {Vehicle}
     * @memberof Price
     */
    vehicle?: Vehicle;
    /**
     * 
     * @type {PriceUnit}
     * @memberof Price
     */
    unit?: PriceUnit;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    price?: number;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof Price
     */
    comment?: Array<Comment>;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    freeMinutes?: number;
}
/**
 * 
 * @export
 * @interface PriceSeason
 */
export interface PriceSeason {
    /**
     * 
     * @type {Season}
     * @memberof PriceSeason
     */
    season?: Season;
    /**
     * 
     * @type {Array<Price>}
     * @memberof PriceSeason
     */
    prices?: Array<Price>;
}
/**
 * 
 * @export
 * @interface PriceSelections
 */
export interface PriceSelections {
    /**
     * 
     * @type {RangeSelection}
     * @memberof PriceSelections
     */
    month?: RangeSelection;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PriceUnit {
    HOUR = 'PER_HOUR',
    HALFHOUR = 'PER_HALFHOUR'
}

/**
 * 
 * @export
 * @interface RangeSelection
 */
export interface RangeSelection {
    /**
     * 
     * @type {number}
     * @memberof RangeSelection
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof RangeSelection
     */
    to?: number;
}
/**
 * 
 * @export
 * @interface RatingsSelections
 */
export interface RatingsSelections {
    /**
     * 
     * @type {boolean}
     * @memberof RatingsSelections
     */
    oeamtcPartner?: boolean;
}
/**
 * 
 * @export
 * @interface RoadClassSelections
 */
export interface RoadClassSelections {
    /**
     * 
     * @type {number}
     * @memberof RoadClassSelections
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof RoadClassSelections
     */
    max?: number;
}
/**
 * 
 * @export
 * @interface RouteParameter
 */
export interface RouteParameter {
    /**
     * 
     * @type {string}
     * @memberof RouteParameter
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteParameter
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface RouteSnapshot
 */
export interface RouteSnapshot {
    /**
     * 
     * @type {string}
     * @memberof RouteSnapshot
     */
    application?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteSnapshot
     */
    lastModified?: string;
    /**
     * 
     * @type {Linestring}
     * @memberof RouteSnapshot
     */
    linestring?: Linestring;
    /**
     * 
     * @type {number}
     * @memberof RouteSnapshot
     */
    duration?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteSnapshot
     */
    distance?: number;
}
/**
 * 
 * @export
 * @interface RouteSnapshotToStore
 */
export interface RouteSnapshotToStore {
    /**
     * 
     * @type {string}
     * @memberof RouteSnapshotToStore
     */
    application?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteSnapshotToStore
     */
    lastModified?: string;
    /**
     * 
     * @type {Linestring}
     * @memberof RouteSnapshotToStore
     */
    linestring?: Linestring;
    /**
     * 
     * @type {number}
     * @memberof RouteSnapshotToStore
     */
    duration?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteSnapshotToStore
     */
    distance?: number;
    /**
     * 
     * @type {Array<Linestring>}
     * @memberof RouteSnapshotToStore
     */
    linestrings?: Array<Linestring>;
}
/**
 * 
 * @export
 * @interface RouteSnapshotToStoreAllOf
 */
export interface RouteSnapshotToStoreAllOf {
    /**
     * 
     * @type {Array<Linestring>}
     * @memberof RouteSnapshotToStoreAllOf
     */
    linestrings?: Array<Linestring>;
}
/**
 * 
 * @export
 * @interface SearchHistory
 */
export interface SearchHistory {
    /**
     * 
     * @type {SearchHistoryType}
     * @memberof SearchHistory
     */
    type?: SearchHistoryType;
    /**
     * 
     * @type {Array<SearchHistoryElement>}
     * @memberof SearchHistory
     */
    elements?: Array<SearchHistoryElement>;
}
/**
 * 
 * @export
 * @interface SearchHistoryElement
 */
export interface SearchHistoryElement {
    /**
     * 
     * @type {string}
     * @memberof SearchHistoryElement
     */
    value?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SearchHistoryType {
    ADDRESS = 'ADDRESS',
    ROUTE = 'ROUTE',
    POI = 'POI'
}

/**
 * 
 * @export
 * @interface Season
 */
export interface Season {
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    to?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Season
     */
    nowValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface SelectionValueList
 */
export interface SelectionValueList {
    /**
     * 
     * @type {Array<string>}
     * @memberof SelectionValueList
     */
    values?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SelectionValueList
     */
    ignoredValues?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SelectionValueList
     */
    operator?: SelectionValueListOperatorEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SelectionValueListOperatorEnum {
    OR = 'OR',
    AND = 'AND'
}

/**
 * 
 * @export
 * @interface ShorttermparkingAttributes
 */
export interface ShorttermparkingAttributes {
    /**
     * 
     * @type {Array<string>}
     * @memberof ShorttermparkingAttributes
     */
    categories?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShorttermparkingAttributes
     */
    groupName?: string;
    /**
     * 
     * @type {Array<PriceSeason>}
     * @memberof ShorttermparkingAttributes
     */
    prices?: Array<PriceSeason>;
    /**
     * 
     * @type {DailyOpeningHours}
     * @memberof ShorttermparkingAttributes
     */
    maxOpeningHours?: DailyOpeningHours;
    /**
     * 
     * @type {number}
     * @memberof ShorttermparkingAttributes
     */
    maxDuration?: number;
}
/**
 * 
 * @export
 * @interface SightAttributes
 */
export interface SightAttributes {
    /**
     * 
     * @type {string}
     * @memberof SightAttributes
     */
    subType?: string;
}
/**
 * 
 * @export
 * @interface SmrContainer
 */
export interface SmrContainer {
    /**
     * 
     * @type {string}
     * @memberof SmrContainer
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SmrContainer
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SmrContainer
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SmrContainer
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof SmrContainer
     */
    lastUpdated?: string;
    /**
     * 
     * @type {ContainerMap}
     * @memberof SmrContainer
     */
    map?: ContainerMap;
    /**
     * 
     * @type {Array<InfoLayer>}
     * @memberof SmrContainer
     */
    infoLayers?: Array<InfoLayer>;
    /**
     * 
     * @type {Array<GeoObject>}
     * @memberof SmrContainer
     */
    geoObjects?: Array<GeoObject>;
    /**
     * 
     * @type {Array<TransportMode>}
     * @memberof SmrContainer
     */
    transportModes?: Array<TransportMode>;
}
/**
 * 
 * @export
 * @interface SmrContainers
 */
export interface SmrContainers {
    /**
     * 
     * @type {Array<SmrContainer>}
     * @memberof SmrContainers
     */
    containers?: Array<SmrContainer>;
}
/**
 * Attributes only available in specific source APIs
 * @export
 * @interface SpecificAttributes
 */
export interface SpecificAttributes {
    /**
     * 
     * @type {ParkingAttributes}
     * @memberof SpecificAttributes
     */
    parking?: ParkingAttributes;
    /**
     * 
     * @type {ShorttermparkingAttributes}
     * @memberof SpecificAttributes
     */
    shorttermparking?: ShorttermparkingAttributes;
    /**
     * 
     * @type {TrafficAttributes}
     * @memberof SpecificAttributes
     */
    traffic?: TrafficAttributes;
    /**
     * 
     * @type {CameraAttributes}
     * @memberof SpecificAttributes
     */
    camera?: CameraAttributes;
    /**
     * 
     * @type {FavoriteAttributes}
     * @memberof SpecificAttributes
     */
    favorite?: FavoriteAttributes;
    /**
     * 
     * @type {FuelAttributes}
     * @memberof SpecificAttributes
     */
    fuel?: FuelAttributes;
    /**
     * 
     * @type {EfuelAttributes}
     * @memberof SpecificAttributes
     */
    efuel?: EfuelAttributes;
    /**
     * 
     * @type {PassroadAttributes}
     * @memberof SpecificAttributes
     */
    passroad?: PassroadAttributes;
    /**
     * 
     * @type {OeamtcAttributes}
     * @memberof SpecificAttributes
     */
    oeamtc?: OeamtcAttributes;
    /**
     * 
     * @type {SightAttributes}
     * @memberof SpecificAttributes
     */
    sight?: SightAttributes;
}
/**
 * 
 * @export
 * @interface TextBlocks
 */
export interface TextBlocks {
    /**
     * HTML table of the opening hours
     * @type {string}
     * @memberof TextBlocks
     */
    openingHours?: string;
    /**
     * HTML Text of the services provided at this location
     * @type {string}
     * @memberof TextBlocks
     */
    services?: string;
}
/**
 * 
 * @export
 * @interface TimeFrame
 */
export interface TimeFrame {
    /**
     * start time in format hh:mm
     * @type {string}
     * @memberof TimeFrame
     */
    from?: string;
    /**
     * end time in format hh:mm
     * @type {string}
     * @memberof TimeFrame
     */
    to?: string;
}
/**
 * Time range filter.
 * @export
 * @interface TimeRangeSelection
 */
export interface TimeRangeSelection {
    /**
     * 
     * @type {string}
     * @memberof TimeRangeSelection
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeRangeSelection
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface TimeSelections
 */
export interface TimeSelections {
    /**
     * 
     * @type {boolean}
     * @memberof TimeSelections
     */
    futureOnly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimeSelections
     */
    periodFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSelections
     */
    periodTo?: string;
}
/**
 * 
 * @export
 * @interface TrafficAttributes
 */
export interface TrafficAttributes {
    /**
     * 
     * @type {string}
     * @memberof TrafficAttributes
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof TrafficAttributes
     */
    roadId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrafficAttributes
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface TransportMode
 */
export interface TransportMode {
    /**
     * 
     * @type {string}
     * @memberof TransportMode
     */
    frontend?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof TransportMode
     */
    settings?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface UserChannel
 */
export interface UserChannel {
    /**
     * 
     * @type {string}
     * @memberof UserChannel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserChannel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserChannel
     */
    path?: string;
    /**
     * 
     * @type {Array<ChannelContextEntry>}
     * @memberof UserChannel
     */
    contextEntries?: Array<ChannelContextEntry>;
}
/**
 * 
 * @export
 * @interface UserRoute
 */
export interface UserRoute {
    /**
     * 
     * @type {string}
     * @memberof UserRoute
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRoute
     */
    gis2Id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRoute
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRoute
     */
    note?: string;
    /**
     * 
     * @type {UserRoutePoint}
     * @memberof UserRoute
     */
    origin?: UserRoutePoint;
    /**
     * 
     * @type {UserRoutePoint}
     * @memberof UserRoute
     */
    destination?: UserRoutePoint;
    /**
     * 
     * @type {Array<UserRoutePoint>}
     * @memberof UserRoute
     */
    vias?: Array<UserRoutePoint>;
    /**
     * 
     * @type {UserChannel}
     * @memberof UserRoute
     */
    channel?: UserChannel;
    /**
     * 
     * @type {Array<RouteParameter>}
     * @memberof UserRoute
     */
    routeParameters?: Array<RouteParameter>;
    /**
     * 
     * @type {string}
     * @memberof UserRoute
     */
    validUntil?: string;
    /**
     * 
     * @type {Array<MeanOfTransport>}
     * @memberof UserRoute
     */
    meansOfTransport?: Array<MeanOfTransport>;
}
/**
 * 
 * @export
 * @interface UserRoutePoint
 */
export interface UserRoutePoint {
    /**
     * 
     * @type {string}
     * @memberof UserRoutePoint
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRoutePoint
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UserRoutePoint
     */
    centerRadius?: number;
    /**
     * 
     * @type {GeoLocation}
     * @memberof UserRoutePoint
     */
    geoLocation?: GeoLocation;
    /**
     * 
     * @type {Bypass}
     * @memberof UserRoutePoint
     */
    bypass?: Bypass;
}
/**
 * 
 * @export
 * @interface UserRoutes
 */
export interface UserRoutes {
    /**
     * 
     * @type {Array<UserRoute>}
     * @memberof UserRoutes
     */
    routes?: Array<UserRoute>;
}
/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {VehicleType}
     * @memberof Vehicle
     */
    type?: VehicleType;
    /**
     * Maximal length in meters
     * @type {number}
     * @memberof Vehicle
     */
    maximumLength?: number;
    /**
     * Maximal height in meters
     * @type {number}
     * @memberof Vehicle
     */
    maximumHeight?: number;
    /**
     * Maximal width in meters
     * @type {number}
     * @memberof Vehicle
     */
    maximumWidth?: number;
    /**
     * Maximal weight in tons
     * @type {number}
     * @memberof Vehicle
     */
    maximumWeight?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VehicleType {
    CAR = 'CAR',
    ELECTRICCAR = 'ELECTRIC_CAR',
    TRUCK = 'TRUCK',
    MOTORCYCLE = 'MOTORCYCLE',
    ELECTRICMOTORCYCLE = 'ELECTRIC_MOTORCYCLE',
    BUS = 'BUS',
    CAMPER = 'CAMPER',
    TRAILER = 'TRAILER',
    BIKE = 'BIKE',
    ELECTRICBIKE = 'ELECTRIC_BIKE',
    BOAT = 'BOAT'
}


/**
 * FavoritesApi - axios parameter creator
 * @export
 */
export const FavoritesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Changes user GIS favorite, returns id
         * @param {string} favoriteId Favorite Id
         * @param {GeoFavorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeGeoFavorite: async (favoriteId: string, favorite: GeoFavorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteId' is not null or undefined
            if (favoriteId === null || favoriteId === undefined) {
                throw new RequiredError('favoriteId','Required parameter favoriteId was null or undefined when calling changeGeoFavorite.');
            }
            // verify required parameter 'favorite' is not null or undefined
            if (favorite === null || favorite === undefined) {
                throw new RequiredError('favorite','Required parameter favorite was null or undefined when calling changeGeoFavorite.');
            }
            const localVarPath = `/favorites/{favoriteId}`
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof favorite !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(favorite !== undefined ? favorite : {}) : (favorite || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes the users oeamtc base
         * @param {ChangeOemtcBase} changeOemtcBase changeOemtcBase
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOeamtcBase: async (changeOemtcBase: ChangeOemtcBase, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeOemtcBase' is not null or undefined
            if (changeOemtcBase === null || changeOemtcBase === undefined) {
                throw new RequiredError('changeOemtcBase','Required parameter changeOemtcBase was null or undefined when calling changeOeamtcBase.');
            }
            const localVarPath = `/favorites/my-oeamtc-base`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof changeOemtcBase !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(changeOemtcBase !== undefined ? changeOemtcBase : {}) : (changeOemtcBase || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Favorite} createFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFavorite: async (createFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFavoriteBody' is not null or undefined
            if (createFavoriteBody === null || createFavoriteBody === undefined) {
                throw new RequiredError('createFavoriteBody','Required parameter createFavoriteBody was null or undefined when calling createFavorite.');
            }
            const localVarPath = `/favorites`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createFavoriteBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createFavoriteBody !== undefined ? createFavoriteBody : {}) : (createFavoriteBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteHome: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/favorites/home`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteWork: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/favorites/work`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes user GIS favorite
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeoFavorite: async (favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteId' is not null or undefined
            if (favoriteId === null || favoriteId === undefined) {
                throw new RequiredError('favoriteId','Required parameter favoriteId was null or undefined when calling deleteGeoFavorite.');
            }
            const localVarPath = `/favorites/{favoriteId}`
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivates the user\'s selected base
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOeamtcBase: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/favorites/my-oeamtc-base`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shows user GIS favorites
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geoFavorites: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/favorites`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shows the users oeamtc base, returns empty respone if the user hasn\'t selected a base yet
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveOeamtcBase: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/favorites/my-oeamtc-base`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorite: async (favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteId' is not null or undefined
            if (favoriteId === null || favoriteId === undefined) {
                throw new RequiredError('favoriteId','Required parameter favoriteId was null or undefined when calling getFavorite.');
            }
            const localVarPath = `/favorites/{favoriteId}`
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteHome: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/favorites/home`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteWork: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/favorites/work`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For this special favorite it is possible to also create it with the PUT verb, if it already exists it will be updated.
         * @param {Favorite} updateFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFavoriteHome: async (updateFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateFavoriteBody' is not null or undefined
            if (updateFavoriteBody === null || updateFavoriteBody === undefined) {
                throw new RequiredError('updateFavoriteBody','Required parameter updateFavoriteBody was null or undefined when calling updateFavoriteHome.');
            }
            const localVarPath = `/favorites/home`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateFavoriteBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateFavoriteBody !== undefined ? updateFavoriteBody : {}) : (updateFavoriteBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For this special favorite it is possible to also create it with the PUT verb, if it already exists it will be updated.
         * @param {Favorite} updateFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFavoriteWork: async (updateFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateFavoriteBody' is not null or undefined
            if (updateFavoriteBody === null || updateFavoriteBody === undefined) {
                throw new RequiredError('updateFavoriteBody','Required parameter updateFavoriteBody was null or undefined when calling updateFavoriteWork.');
            }
            const localVarPath = `/favorites/work`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateFavoriteBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateFavoriteBody !== undefined ? updateFavoriteBody : {}) : (updateFavoriteBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FavoritesApi - functional programming interface
 * @export
 */
export const FavoritesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Changes user GIS favorite, returns id
         * @param {string} favoriteId Favorite Id
         * @param {GeoFavorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeGeoFavorite(favoriteId: string, favorite: GeoFavorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdResponse>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).changeGeoFavorite(favoriteId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Changes the users oeamtc base
         * @param {ChangeOemtcBase} changeOemtcBase changeOemtcBase
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeOeamtcBase(changeOemtcBase: ChangeOemtcBase, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).changeOeamtcBase(changeOemtcBase, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Favorite} createFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFavorite(createFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).createFavorite(createFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFavoriteHome(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).deleteFavoriteHome(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFavoriteWork(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).deleteFavoriteWork(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes user GIS favorite
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGeoFavorite(favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).deleteGeoFavorite(favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deactivates the user\'s selected base
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOeamtcBase(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).deleteOeamtcBase(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Shows user GIS favorites
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geoFavorites(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeoFavorite>>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).geoFavorites(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Shows the users oeamtc base, returns empty respone if the user hasn\'t selected a base yet
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveOeamtcBase(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Base>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).getActiveOeamtcBase(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavorite(favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).getFavorite(favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoriteHome(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).getFavoriteHome(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoriteWork(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).getFavoriteWork(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * For this special favorite it is possible to also create it with the PUT verb, if it already exists it will be updated.
         * @param {Favorite} updateFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFavoriteHome(updateFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).updateFavoriteHome(updateFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * For this special favorite it is possible to also create it with the PUT verb, if it already exists it will be updated.
         * @param {Favorite} updateFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFavoriteWork(updateFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await FavoritesApiAxiosParamCreator(configuration).updateFavoriteWork(updateFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FavoritesApi - factory interface
 * @export
 */
export const FavoritesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Changes user GIS favorite, returns id
         * @param {string} favoriteId Favorite Id
         * @param {GeoFavorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeGeoFavorite(favoriteId: string, favorite: GeoFavorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<IdResponse> {
            return FavoritesApiFp(configuration).changeGeoFavorite(favoriteId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes the users oeamtc base
         * @param {ChangeOemtcBase} changeOemtcBase changeOemtcBase
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOeamtcBase(changeOemtcBase: ChangeOemtcBase, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return FavoritesApiFp(configuration).changeOeamtcBase(changeOemtcBase, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Favorite} createFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFavorite(createFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Favorite> {
            return FavoritesApiFp(configuration).createFavorite(createFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteHome(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return FavoritesApiFp(configuration).deleteFavoriteHome(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteWork(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return FavoritesApiFp(configuration).deleteFavoriteWork(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes user GIS favorite
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeoFavorite(favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return FavoritesApiFp(configuration).deleteGeoFavorite(favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivates the user\'s selected base
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOeamtcBase(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return FavoritesApiFp(configuration).deleteOeamtcBase(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shows user GIS favorites
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geoFavorites(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Array<GeoFavorite>> {
            return FavoritesApiFp(configuration).geoFavorites(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shows the users oeamtc base, returns empty respone if the user hasn\'t selected a base yet
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveOeamtcBase(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Base> {
            return FavoritesApiFp(configuration).getActiveOeamtcBase(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorite(favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Favorite> {
            return FavoritesApiFp(configuration).getFavorite(favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteHome(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Favorite> {
            return FavoritesApiFp(configuration).getFavoriteHome(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteWork(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Favorite> {
            return FavoritesApiFp(configuration).getFavoriteWork(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * For this special favorite it is possible to also create it with the PUT verb, if it already exists it will be updated.
         * @param {Favorite} updateFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFavoriteHome(updateFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Favorite> {
            return FavoritesApiFp(configuration).updateFavoriteHome(updateFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * For this special favorite it is possible to also create it with the PUT verb, if it already exists it will be updated.
         * @param {Favorite} updateFavoriteBody 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFavoriteWork(updateFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Favorite> {
            return FavoritesApiFp(configuration).updateFavoriteWork(updateFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FavoritesApi - object-oriented interface
 * @export
 * @class FavoritesApi
 * @extends {BaseAPI}
 */
export class FavoritesApi extends BaseAPI {
    /**
     * 
     * @summary Changes user GIS favorite, returns id
     * @param {string} favoriteId Favorite Id
     * @param {GeoFavorite} favorite favorite
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public changeGeoFavorite(favoriteId: string, favorite: GeoFavorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).changeGeoFavorite(favoriteId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes the users oeamtc base
     * @param {ChangeOemtcBase} changeOemtcBase changeOemtcBase
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public changeOeamtcBase(changeOemtcBase: ChangeOemtcBase, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).changeOeamtcBase(changeOemtcBase, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Favorite} createFavoriteBody 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public createFavorite(createFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).createFavorite(createFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public deleteFavoriteHome(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).deleteFavoriteHome(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public deleteFavoriteWork(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).deleteFavoriteWork(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes user GIS favorite
     * @param {string} favoriteId Favorite Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public deleteGeoFavorite(favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).deleteGeoFavorite(favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivates the user\'s selected base
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public deleteOeamtcBase(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).deleteOeamtcBase(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shows user GIS favorites
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public geoFavorites(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).geoFavorites(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shows the users oeamtc base, returns empty respone if the user hasn\'t selected a base yet
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public getActiveOeamtcBase(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).getActiveOeamtcBase(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} favoriteId Favorite Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public getFavorite(favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).getFavorite(favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public getFavoriteHome(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).getFavoriteHome(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public getFavoriteWork(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).getFavoriteWork(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For this special favorite it is possible to also create it with the PUT verb, if it already exists it will be updated.
     * @param {Favorite} updateFavoriteBody 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public updateFavoriteHome(updateFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).updateFavoriteHome(updateFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For this special favorite it is possible to also create it with the PUT verb, if it already exists it will be updated.
     * @param {Favorite} updateFavoriteBody 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesApi
     */
    public updateFavoriteWork(updateFavoriteBody: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesApiFp(this.configuration).updateFavoriteWork(updateFavoriteBody, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FavoritesListsApi - axios parameter creator
 * @export
 */
export const FavoritesListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Changes user GIS favorites list, returns id
         * @param {string} favoriteListId Favorite list Id
         * @param {FavoritesListEntry} listEntry listEntry
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeGeoFavoritesList: async (favoriteListId: string, listEntry: FavoritesListEntry, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteListId' is not null or undefined
            if (favoriteListId === null || favoriteListId === undefined) {
                throw new RequiredError('favoriteListId','Required parameter favoriteListId was null or undefined when calling changeGeoFavoritesList.');
            }
            // verify required parameter 'listEntry' is not null or undefined
            if (listEntry === null || listEntry === undefined) {
                throw new RequiredError('listEntry','Required parameter listEntry was null or undefined when calling changeGeoFavoritesList.');
            }
            const localVarPath = `/favorites/lists/{favoriteListId}`
                .replace(`{${"favoriteListId"}}`, encodeURIComponent(String(favoriteListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof listEntry !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(listEntry !== undefined ? listEntry : {}) : (listEntry || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates user GIS favorites list, returns id
         * @param {FavoritesListEntry} listEntry listEntry
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGeoFavoritesList: async (listEntry: FavoritesListEntry, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listEntry' is not null or undefined
            if (listEntry === null || listEntry === undefined) {
                throw new RequiredError('listEntry','Required parameter listEntry was null or undefined when calling createGeoFavoritesList.');
            }
            const localVarPath = `/favorites/lists`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof listEntry !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(listEntry !== undefined ? listEntry : {}) : (listEntry || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add GIS favorites to user GIS favorites list, returns id
         * @param {string} favoriteListId Favorite list Id
         * @param {GeoFavorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGeoFavoritesListFavorites: async (favoriteListId: string, favorite: GeoFavorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteListId' is not null or undefined
            if (favoriteListId === null || favoriteListId === undefined) {
                throw new RequiredError('favoriteListId','Required parameter favoriteListId was null or undefined when calling createGeoFavoritesListFavorites.');
            }
            // verify required parameter 'favorite' is not null or undefined
            if (favorite === null || favorite === undefined) {
                throw new RequiredError('favorite','Required parameter favorite was null or undefined when calling createGeoFavoritesListFavorites.');
            }
            const localVarPath = `/favorites/lists/{favoriteListId}/favorites`
                .replace(`{${"favoriteListId"}}`, encodeURIComponent(String(favoriteListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof favorite !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(favorite !== undefined ? favorite : {}) : (favorite || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoritesListFavorite: async (favoriteListId: string, favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteListId' is not null or undefined
            if (favoriteListId === null || favoriteListId === undefined) {
                throw new RequiredError('favoriteListId','Required parameter favoriteListId was null or undefined when calling deleteFavoritesListFavorite.');
            }
            // verify required parameter 'favoriteId' is not null or undefined
            if (favoriteId === null || favoriteId === undefined) {
                throw new RequiredError('favoriteId','Required parameter favoriteId was null or undefined when calling deleteFavoritesListFavorite.');
            }
            const localVarPath = `/favorites/lists/{favoriteListId}/favorite/{favoriteId}`
                .replace(`{${"favoriteListId"}}`, encodeURIComponent(String(favoriteListId)))
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes user GIS favorites list
         * @param {string} favoriteListId Favorite list Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeoFavoritesList: async (favoriteListId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteListId' is not null or undefined
            if (favoriteListId === null || favoriteListId === undefined) {
                throw new RequiredError('favoriteListId','Required parameter favoriteListId was null or undefined when calling deleteGeoFavoritesList.');
            }
            const localVarPath = `/favorites/lists/{favoriteListId}`
                .replace(`{${"favoriteListId"}}`, encodeURIComponent(String(favoriteListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shows user GIS favorites in lists
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geoFavoritesLists: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/favorites/lists`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesList: async (favoriteListId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteListId' is not null or undefined
            if (favoriteListId === null || favoriteListId === undefined) {
                throw new RequiredError('favoriteListId','Required parameter favoriteListId was null or undefined when calling getFavoritesList.');
            }
            const localVarPath = `/favorites/lists/{favoriteListId}`
                .replace(`{${"favoriteListId"}}`, encodeURIComponent(String(favoriteListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesListFavorite: async (favoriteListId: string, favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteListId' is not null or undefined
            if (favoriteListId === null || favoriteListId === undefined) {
                throw new RequiredError('favoriteListId','Required parameter favoriteListId was null or undefined when calling getFavoritesListFavorite.');
            }
            // verify required parameter 'favoriteId' is not null or undefined
            if (favoriteId === null || favoriteId === undefined) {
                throw new RequiredError('favoriteId','Required parameter favoriteId was null or undefined when calling getFavoritesListFavorite.');
            }
            const localVarPath = `/favorites/lists/{favoriteListId}/favorite/{favoriteId}`
                .replace(`{${"favoriteListId"}}`, encodeURIComponent(String(favoriteListId)))
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {Favorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFavoritesListFavorite: async (favoriteListId: string, favoriteId: string, favorite: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteListId' is not null or undefined
            if (favoriteListId === null || favoriteListId === undefined) {
                throw new RequiredError('favoriteListId','Required parameter favoriteListId was null or undefined when calling updateFavoritesListFavorite.');
            }
            // verify required parameter 'favoriteId' is not null or undefined
            if (favoriteId === null || favoriteId === undefined) {
                throw new RequiredError('favoriteId','Required parameter favoriteId was null or undefined when calling updateFavoritesListFavorite.');
            }
            // verify required parameter 'favorite' is not null or undefined
            if (favorite === null || favorite === undefined) {
                throw new RequiredError('favorite','Required parameter favorite was null or undefined when calling updateFavoritesListFavorite.');
            }
            const localVarPath = `/favorites/lists/{favoriteListId}/favorite/{favoriteId}`
                .replace(`{${"favoriteListId"}}`, encodeURIComponent(String(favoriteListId)))
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof favorite !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(favorite !== undefined ? favorite : {}) : (favorite || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FavoritesListsApi - functional programming interface
 * @export
 */
export const FavoritesListsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Changes user GIS favorites list, returns id
         * @param {string} favoriteListId Favorite list Id
         * @param {FavoritesListEntry} listEntry listEntry
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeGeoFavoritesList(favoriteListId: string, listEntry: FavoritesListEntry, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoritesListEntry>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).changeGeoFavoritesList(favoriteListId, listEntry, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Creates user GIS favorites list, returns id
         * @param {FavoritesListEntry} listEntry listEntry
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGeoFavoritesList(listEntry: FavoritesListEntry, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoritesListEntry>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).createGeoFavoritesList(listEntry, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add GIS favorites to user GIS favorites list, returns id
         * @param {string} favoriteListId Favorite list Id
         * @param {GeoFavorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGeoFavoritesListFavorites(favoriteListId: string, favorite: GeoFavorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdResponse>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).createGeoFavoritesListFavorites(favoriteListId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFavoritesListFavorite(favoriteListId: string, favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).deleteFavoritesListFavorite(favoriteListId, favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes user GIS favorites list
         * @param {string} favoriteListId Favorite list Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGeoFavoritesList(favoriteListId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).deleteGeoFavoritesList(favoriteListId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Shows user GIS favorites in lists
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geoFavoritesLists(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoritesListResponse>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).geoFavoritesLists(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoritesList(favoriteListId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoritesList>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).getFavoritesList(favoriteListId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoritesListFavorite(favoriteListId: string, favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).getFavoritesListFavorite(favoriteListId, favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {Favorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFavoritesListFavorite(favoriteListId: string, favoriteId: string, favorite: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoritesList>> {
            const localVarAxiosArgs = await FavoritesListsApiAxiosParamCreator(configuration).updateFavoritesListFavorite(favoriteListId, favoriteId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FavoritesListsApi - factory interface
 * @export
 */
export const FavoritesListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Changes user GIS favorites list, returns id
         * @param {string} favoriteListId Favorite list Id
         * @param {FavoritesListEntry} listEntry listEntry
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeGeoFavoritesList(favoriteListId: string, listEntry: FavoritesListEntry, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<FavoritesListEntry> {
            return FavoritesListsApiFp(configuration).changeGeoFavoritesList(favoriteListId, listEntry, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates user GIS favorites list, returns id
         * @param {FavoritesListEntry} listEntry listEntry
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGeoFavoritesList(listEntry: FavoritesListEntry, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<FavoritesListEntry> {
            return FavoritesListsApiFp(configuration).createGeoFavoritesList(listEntry, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add GIS favorites to user GIS favorites list, returns id
         * @param {string} favoriteListId Favorite list Id
         * @param {GeoFavorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGeoFavoritesListFavorites(favoriteListId: string, favorite: GeoFavorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<IdResponse> {
            return FavoritesListsApiFp(configuration).createGeoFavoritesListFavorites(favoriteListId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoritesListFavorite(favoriteListId: string, favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return FavoritesListsApiFp(configuration).deleteFavoritesListFavorite(favoriteListId, favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes user GIS favorites list
         * @param {string} favoriteListId Favorite list Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeoFavoritesList(favoriteListId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return FavoritesListsApiFp(configuration).deleteGeoFavoritesList(favoriteListId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shows user GIS favorites in lists
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geoFavoritesLists(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<FavoritesListResponse> {
            return FavoritesListsApiFp(configuration).geoFavoritesLists(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesList(favoriteListId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<FavoritesList> {
            return FavoritesListsApiFp(configuration).getFavoritesList(favoriteListId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritesListFavorite(favoriteListId: string, favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<Favorite> {
            return FavoritesListsApiFp(configuration).getFavoritesListFavorite(favoriteListId, favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} favoriteListId Favorite list Id
         * @param {string} favoriteId Favorite Id
         * @param {Favorite} favorite favorite
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFavoritesListFavorite(favoriteListId: string, favoriteId: string, favorite: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<FavoritesList> {
            return FavoritesListsApiFp(configuration).updateFavoritesListFavorite(favoriteListId, favoriteId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FavoritesListsApi - object-oriented interface
 * @export
 * @class FavoritesListsApi
 * @extends {BaseAPI}
 */
export class FavoritesListsApi extends BaseAPI {
    /**
     * 
     * @summary Changes user GIS favorites list, returns id
     * @param {string} favoriteListId Favorite list Id
     * @param {FavoritesListEntry} listEntry listEntry
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public changeGeoFavoritesList(favoriteListId: string, listEntry: FavoritesListEntry, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).changeGeoFavoritesList(favoriteListId, listEntry, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates user GIS favorites list, returns id
     * @param {FavoritesListEntry} listEntry listEntry
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public createGeoFavoritesList(listEntry: FavoritesListEntry, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).createGeoFavoritesList(listEntry, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add GIS favorites to user GIS favorites list, returns id
     * @param {string} favoriteListId Favorite list Id
     * @param {GeoFavorite} favorite favorite
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public createGeoFavoritesListFavorites(favoriteListId: string, favorite: GeoFavorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).createGeoFavoritesListFavorites(favoriteListId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} favoriteListId Favorite list Id
     * @param {string} favoriteId Favorite Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public deleteFavoritesListFavorite(favoriteListId: string, favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).deleteFavoritesListFavorite(favoriteListId, favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes user GIS favorites list
     * @param {string} favoriteListId Favorite list Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public deleteGeoFavoritesList(favoriteListId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).deleteGeoFavoritesList(favoriteListId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shows user GIS favorites in lists
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public geoFavoritesLists(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).geoFavoritesLists(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} favoriteListId Favorite list Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public getFavoritesList(favoriteListId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).getFavoritesList(favoriteListId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} favoriteListId Favorite list Id
     * @param {string} favoriteId Favorite Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public getFavoritesListFavorite(favoriteListId: string, favoriteId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).getFavoritesListFavorite(favoriteListId, favoriteId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} favoriteListId Favorite list Id
     * @param {string} favoriteId Favorite Id
     * @param {Favorite} favorite favorite
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesListsApi
     */
    public updateFavoritesListFavorite(favoriteListId: string, favoriteId: string, favorite: Favorite, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return FavoritesListsApiFp(this.configuration).updateFavoritesListFavorite(favoriteListId, favoriteId, favorite, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MasterdataApi - axios parameter creator
 * @export
 */
export const MasterdataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available GIS points of interest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPois: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterdata/poi/oeamtc`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all GIS oeamtc bases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOeamtcBases: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterdata/poi/oeamtc/bases`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterdataApi - functional programming interface
 * @export
 */
export const MasterdataApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available GIS points of interest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPois(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Poi>>> {
            const localVarAxiosArgs = await MasterdataApiAxiosParamCreator(configuration).getAllPois(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary List all GIS oeamtc bases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOeamtcBases(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Poi>>> {
            const localVarAxiosArgs = await MasterdataApiAxiosParamCreator(configuration).getOeamtcBases(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MasterdataApi - factory interface
 * @export
 */
export const MasterdataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary List all available GIS points of interest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPois(options?: any): AxiosPromise<Array<Poi>> {
            return MasterdataApiFp(configuration).getAllPois(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all GIS oeamtc bases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOeamtcBases(options?: any): AxiosPromise<Array<Poi>> {
            return MasterdataApiFp(configuration).getOeamtcBases(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterdataApi - object-oriented interface
 * @export
 * @class MasterdataApi
 * @extends {BaseAPI}
 */
export class MasterdataApi extends BaseAPI {
    /**
     * 
     * @summary List all available GIS points of interest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterdataApi
     */
    public getAllPois(options?: any) {
        return MasterdataApiFp(this.configuration).getAllPois(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all GIS oeamtc bases
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterdataApi
     */
    public getOeamtcBases(options?: any) {
        return MasterdataApiFp(this.configuration).getOeamtcBases(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MultiApi - axios parameter creator
 * @export
 */
export const MultiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Combines GIS Poi APIs for all webuser favorites.
         * @summary List favorites for webuser
         * @param {MultiSelections} multiSelections Selections object to use for filters and facets
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {number} [start] Paging: start index
         * @param {number} [count] Paging: number of elements
         * @param {'NAME_ASC' | 'DISTANCE_ASC'} [sort] Sorting
         * @param {string} [userCoordinates] POINT in WKT notation (longitude latitude)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFavorites: async (multiSelections: MultiSelections, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, start?: number, count?: number, sort?: 'NAME_ASC' | 'DISTANCE_ASC', userCoordinates?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'multiSelections' is not null or undefined
            if (multiSelections === null || multiSelections === undefined) {
                throw new RequiredError('multiSelections','Required parameter multiSelections was null or undefined when calling searchFavorites.');
            }
            const localVarPath = `/favorites/multi`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (userCoordinates !== undefined) {
                localVarQueryParameter['userCoordinates'] = userCoordinates;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof multiSelections !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(multiSelections !== undefined ? multiSelections : {}) : (multiSelections || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MultiApi - functional programming interface
 * @export
 */
export const MultiApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Combines GIS Poi APIs for all webuser favorites.
         * @summary List favorites for webuser
         * @param {MultiSelections} multiSelections Selections object to use for filters and facets
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {number} [start] Paging: start index
         * @param {number} [count] Paging: number of elements
         * @param {'NAME_ASC' | 'DISTANCE_ASC'} [sort] Sorting
         * @param {string} [userCoordinates] POINT in WKT notation (longitude latitude)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFavorites(multiSelections: MultiSelections, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, start?: number, count?: number, sort?: 'NAME_ASC' | 'DISTANCE_ASC', userCoordinates?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiResultList>> {
            const localVarAxiosArgs = await MultiApiAxiosParamCreator(configuration).searchFavorites(multiSelections, oeamtcIdentityKey, oeamtcIdentityMaUsername, start, count, sort, userCoordinates, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MultiApi - factory interface
 * @export
 */
export const MultiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Combines GIS Poi APIs for all webuser favorites.
         * @summary List favorites for webuser
         * @param {MultiSelections} multiSelections Selections object to use for filters and facets
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {number} [start] Paging: start index
         * @param {number} [count] Paging: number of elements
         * @param {'NAME_ASC' | 'DISTANCE_ASC'} [sort] Sorting
         * @param {string} [userCoordinates] POINT in WKT notation (longitude latitude)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFavorites(multiSelections: MultiSelections, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, start?: number, count?: number, sort?: 'NAME_ASC' | 'DISTANCE_ASC', userCoordinates?: string, options?: any): AxiosPromise<MultiResultList> {
            return MultiApiFp(configuration).searchFavorites(multiSelections, oeamtcIdentityKey, oeamtcIdentityMaUsername, start, count, sort, userCoordinates, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MultiApi - object-oriented interface
 * @export
 * @class MultiApi
 * @extends {BaseAPI}
 */
export class MultiApi extends BaseAPI {
    /**
     * Combines GIS Poi APIs for all webuser favorites.
     * @summary List favorites for webuser
     * @param {MultiSelections} multiSelections Selections object to use for filters and facets
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {number} [start] Paging: start index
     * @param {number} [count] Paging: number of elements
     * @param {'NAME_ASC' | 'DISTANCE_ASC'} [sort] Sorting
     * @param {string} [userCoordinates] POINT in WKT notation (longitude latitude)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MultiApi
     */
    public searchFavorites(multiSelections: MultiSelections, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, start?: number, count?: number, sort?: 'NAME_ASC' | 'DISTANCE_ASC', userCoordinates?: string, options?: any) {
        return MultiApiFp(this.configuration).searchFavorites(multiSelections, oeamtcIdentityKey, oeamtcIdentityMaUsername, start, count, sort, userCoordinates, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PoiApi - axios parameter creator
 * @export
 */
export const PoiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return the detailed view of an oeamtc base
         * @param {string} baseId Id for the base i.e. st-12345
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOeamtcBase: async (baseId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseId' is not null or undefined
            if (baseId === null || baseId === undefined) {
                throw new RequiredError('baseId','Required parameter baseId was null or undefined when calling getOeamtcBase.');
            }
            const localVarPath = `/poi/oeamtc/{baseId}`
                .replace(`{${"baseId"}}`, encodeURIComponent(String(baseId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoiApi - functional programming interface
 * @export
 */
export const PoiApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return the detailed view of an oeamtc base
         * @param {string} baseId Id for the base i.e. st-12345
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOeamtcBase(baseId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Base>> {
            const localVarAxiosArgs = await PoiApiAxiosParamCreator(configuration).getOeamtcBase(baseId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PoiApi - factory interface
 * @export
 */
export const PoiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return the detailed view of an oeamtc base
         * @param {string} baseId Id for the base i.e. st-12345
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOeamtcBase(baseId: string, options?: any): AxiosPromise<Base> {
            return PoiApiFp(configuration).getOeamtcBase(baseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PoiApi - object-oriented interface
 * @export
 * @class PoiApi
 * @extends {BaseAPI}
 */
export class PoiApi extends BaseAPI {
    /**
     * 
     * @summary Return the detailed view of an oeamtc base
     * @param {string} baseId Id for the base i.e. st-12345
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoiApi
     */
    public getOeamtcBase(baseId: string, options?: any) {
        return PoiApiFp(this.configuration).getOeamtcBase(baseId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RecommendationsApi - axios parameter creator
 * @export
 */
export const RecommendationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get the client\'s latitude and longitude using their ip address
         * @param {string} xRealIp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeolocationOfUser: async (xRealIp: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xRealIp' is not null or undefined
            if (xRealIp === null || xRealIp === undefined) {
                throw new RequiredError('xRealIp','Required parameter xRealIp was null or undefined when calling getGeolocationOfUser.');
            }
            const localVarPath = `/geolocations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRealIp !== undefined && xRealIp !== null) {
                localVarHeaderParameter['x-real-ip'] = String(xRealIp);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * recommend the nearest oeamtc base to the client using their location
         * @param {string} xRealIp 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {string} [oeamtcIdentityKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendBaseForUser: async (xRealIp: string, lat?: number, lng?: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xRealIp' is not null or undefined
            if (xRealIp === null || xRealIp === undefined) {
                throw new RequiredError('xRealIp','Required parameter xRealIp was null or undefined when calling recommendBaseForUser.');
            }
            const localVarPath = `/recommendations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (xRealIp !== undefined && xRealIp !== null) {
                localVarHeaderParameter['x-real-ip'] = String(xRealIp);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecommendationsApi - functional programming interface
 * @export
 */
export const RecommendationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * get the client\'s latitude and longitude using their ip address
         * @param {string} xRealIp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeolocationOfUser(xRealIp: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
            const localVarAxiosArgs = await RecommendationsApiAxiosParamCreator(configuration).getGeolocationOfUser(xRealIp, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * recommend the nearest oeamtc base to the client using their location
         * @param {string} xRealIp 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {string} [oeamtcIdentityKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendBaseForUser(xRealIp: string, lat?: number, lng?: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Base>> {
            const localVarAxiosArgs = await RecommendationsApiAxiosParamCreator(configuration).recommendBaseForUser(xRealIp, lat, lng, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RecommendationsApi - factory interface
 * @export
 */
export const RecommendationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * get the client\'s latitude and longitude using their ip address
         * @param {string} xRealIp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeolocationOfUser(xRealIp: string, options?: any): AxiosPromise<Location> {
            return RecommendationsApiFp(configuration).getGeolocationOfUser(xRealIp, options).then((request) => request(axios, basePath));
        },
        /**
         * recommend the nearest oeamtc base to the client using their location
         * @param {string} xRealIp 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {string} [oeamtcIdentityKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendBaseForUser(xRealIp: string, lat?: number, lng?: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Base> {
            return RecommendationsApiFp(configuration).recommendBaseForUser(xRealIp, lat, lng, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecommendationsApi - object-oriented interface
 * @export
 * @class RecommendationsApi
 * @extends {BaseAPI}
 */
export class RecommendationsApi extends BaseAPI {
    /**
     * get the client\'s latitude and longitude using their ip address
     * @param {string} xRealIp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public getGeolocationOfUser(xRealIp: string, options?: any) {
        return RecommendationsApiFp(this.configuration).getGeolocationOfUser(xRealIp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * recommend the nearest oeamtc base to the client using their location
     * @param {string} xRealIp 
     * @param {number} [lat] 
     * @param {number} [lng] 
     * @param {string} [oeamtcIdentityKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public recommendBaseForUser(xRealIp: string, lat?: number, lng?: number, oeamtcIdentityKey?: string, options?: any) {
        return RecommendationsApiFp(this.configuration).recommendBaseForUser(xRealIp, lat, lng, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RoutesApi - axios parameter creator
 * @export
 */
export const RoutesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserRoute} userRoute 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoute: async (userRoute: UserRoute, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRoute' is not null or undefined
            if (userRoute === null || userRoute === undefined) {
                throw new RequiredError('userRoute','Required parameter userRoute was null or undefined when calling createRoute.');
            }
            const localVarPath = `/routes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userRoute !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userRoute !== undefined ? userRoute : {}) : (userRoute || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoute: async (routeId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            if (routeId === null || routeId === undefined) {
                throw new RequiredError('routeId','Required parameter routeId was null or undefined when calling deleteRoute.');
            }
            const localVarPath = `/routes/{routeId}`
                .replace(`{${"routeId"}}`, encodeURIComponent(String(routeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} validUntil Deletes all user-specific routes older than the given date
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRouteOlderThan: async (validUntil: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'validUntil' is not null or undefined
            if (validUntil === null || validUntil === undefined) {
                throw new RequiredError('validUntil','Required parameter validUntil was null or undefined when calling deleteRouteOlderThan.');
            }
            const localVarPath = `/routes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (validUntil !== undefined) {
                localVarQueryParameter['validUntil'] = (validUntil as any instanceof Date) ?
                    (validUntil as any).toISOString().substr(0,10) :
                    validUntil;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {boolean} [includeDetail] Include details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoutes: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, includeDetail?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/routes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeDetail !== undefined) {
                localVarQueryParameter['includeDetail'] = includeDetail;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoute: async (routeId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            if (routeId === null || routeId === undefined) {
                throw new RequiredError('routeId','Required parameter routeId was null or undefined when calling getRoute.');
            }
            const localVarPath = `/routes/{routeId}`
                .replace(`{${"routeId"}}`, encodeURIComponent(String(routeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteSnapshot: async (routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            if (routeId === null || routeId === undefined) {
                throw new RequiredError('routeId','Required parameter routeId was null or undefined when calling getRouteSnapshot.');
            }
            // verify required parameter 'application' is not null or undefined
            if (application === null || application === undefined) {
                throw new RequiredError('application','Required parameter application was null or undefined when calling getRouteSnapshot.');
            }
            const localVarPath = `/routes/{routeId}/snapshot/{application}`
                .replace(`{${"routeId"}}`, encodeURIComponent(String(routeId)))
                .replace(`{${"application"}}`, encodeURIComponent(String(application)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headRouteSnapshot: async (routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            if (routeId === null || routeId === undefined) {
                throw new RequiredError('routeId','Required parameter routeId was null or undefined when calling headRouteSnapshot.');
            }
            // verify required parameter 'application' is not null or undefined
            if (application === null || application === undefined) {
                throw new RequiredError('application','Required parameter application was null or undefined when calling headRouteSnapshot.');
            }
            const localVarPath = `/routes/{routeId}/snapshot/{application}`
                .replace(`{${"routeId"}}`, encodeURIComponent(String(routeId)))
                .replace(`{${"application"}}`, encodeURIComponent(String(application)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {RouteSnapshotToStore} routeSnapshot 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRouteSnapshot: async (routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', routeSnapshot: RouteSnapshotToStore, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            if (routeId === null || routeId === undefined) {
                throw new RequiredError('routeId','Required parameter routeId was null or undefined when calling saveRouteSnapshot.');
            }
            // verify required parameter 'application' is not null or undefined
            if (application === null || application === undefined) {
                throw new RequiredError('application','Required parameter application was null or undefined when calling saveRouteSnapshot.');
            }
            // verify required parameter 'routeSnapshot' is not null or undefined
            if (routeSnapshot === null || routeSnapshot === undefined) {
                throw new RequiredError('routeSnapshot','Required parameter routeSnapshot was null or undefined when calling saveRouteSnapshot.');
            }
            const localVarPath = `/routes/{routeId}/snapshot/{application}`
                .replace(`{${"routeId"}}`, encodeURIComponent(String(routeId)))
                .replace(`{${"application"}}`, encodeURIComponent(String(application)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof routeSnapshot !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(routeSnapshot !== undefined ? routeSnapshot : {}) : (routeSnapshot || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {UserRoute} userRoute 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoute: async (routeId: string, userRoute: UserRoute, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            if (routeId === null || routeId === undefined) {
                throw new RequiredError('routeId','Required parameter routeId was null or undefined when calling updateRoute.');
            }
            // verify required parameter 'userRoute' is not null or undefined
            if (userRoute === null || userRoute === undefined) {
                throw new RequiredError('userRoute','Required parameter userRoute was null or undefined when calling updateRoute.');
            }
            const localVarPath = `/routes/{routeId}`
                .replace(`{${"routeId"}}`, encodeURIComponent(String(routeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userRoute !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userRoute !== undefined ? userRoute : {}) : (userRoute || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoutesApi - functional programming interface
 * @export
 */
export const RoutesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserRoute} userRoute 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoute(userRoute: UserRoute, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRoute>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).createRoute(userRoute, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoute(routeId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).deleteRoute(routeId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} validUntil Deletes all user-specific routes older than the given date
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRouteOlderThan(validUntil: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).deleteRouteOlderThan(validUntil, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {boolean} [includeDetail] Include details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRoutes(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, includeDetail?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRoutes>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).getAllRoutes(oeamtcIdentityKey, oeamtcIdentityMaUsername, includeDetail, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoute(routeId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRoute>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).getRoute(routeId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteSnapshot>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).getRouteSnapshot(routeId, application, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async headRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).headRouteSnapshot(routeId, application, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {RouteSnapshotToStore} routeSnapshot 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', routeSnapshot: RouteSnapshotToStore, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteSnapshot>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).saveRouteSnapshot(routeId, application, routeSnapshot, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {UserRoute} userRoute 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoute(routeId: string, userRoute: UserRoute, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRoute>> {
            const localVarAxiosArgs = await RoutesApiAxiosParamCreator(configuration).updateRoute(routeId, userRoute, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RoutesApi - factory interface
 * @export
 */
export const RoutesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {UserRoute} userRoute 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoute(userRoute: UserRoute, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<UserRoute> {
            return RoutesApiFp(configuration).createRoute(userRoute, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoute(routeId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return RoutesApiFp(configuration).deleteRoute(routeId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} validUntil Deletes all user-specific routes older than the given date
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRouteOlderThan(validUntil: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return RoutesApiFp(configuration).deleteRouteOlderThan(validUntil, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {boolean} [includeDetail] Include details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoutes(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, includeDetail?: boolean, options?: any): AxiosPromise<UserRoutes> {
            return RoutesApiFp(configuration).getAllRoutes(oeamtcIdentityKey, oeamtcIdentityMaUsername, includeDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoute(routeId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<UserRoute> {
            return RoutesApiFp(configuration).getRoute(routeId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<RouteSnapshot> {
            return RoutesApiFp(configuration).getRouteSnapshot(routeId, application, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return RoutesApiFp(configuration).headRouteSnapshot(routeId, application, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
         * @param {RouteSnapshotToStore} routeSnapshot 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', routeSnapshot: RouteSnapshotToStore, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<RouteSnapshot> {
            return RoutesApiFp(configuration).saveRouteSnapshot(routeId, application, routeSnapshot, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} routeId Route Id
         * @param {UserRoute} userRoute 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoute(routeId: string, userRoute: UserRoute, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<UserRoute> {
            return RoutesApiFp(configuration).updateRoute(routeId, userRoute, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoutesApi - object-oriented interface
 * @export
 * @class RoutesApi
 * @extends {BaseAPI}
 */
export class RoutesApi extends BaseAPI {
    /**
     * 
     * @param {UserRoute} userRoute 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public createRoute(userRoute: UserRoute, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return RoutesApiFp(this.configuration).createRoute(userRoute, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} routeId Route Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public deleteRoute(routeId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return RoutesApiFp(this.configuration).deleteRoute(routeId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} validUntil Deletes all user-specific routes older than the given date
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public deleteRouteOlderThan(validUntil: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return RoutesApiFp(this.configuration).deleteRouteOlderThan(validUntil, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {boolean} [includeDetail] Include details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public getAllRoutes(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, includeDetail?: boolean, options?: any) {
        return RoutesApiFp(this.configuration).getAllRoutes(oeamtcIdentityKey, oeamtcIdentityMaUsername, includeDetail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} routeId Route Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public getRoute(routeId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return RoutesApiFp(this.configuration).getRoute(routeId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} routeId Route Id
     * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public getRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return RoutesApiFp(this.configuration).getRouteSnapshot(routeId, application, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} routeId Route Id
     * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public headRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return RoutesApiFp(this.configuration).headRouteSnapshot(routeId, application, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} routeId Route Id
     * @param {'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO'} application Application for route snapshot
     * @param {RouteSnapshotToStore} routeSnapshot 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public saveRouteSnapshot(routeId: string, application: 'SMR' | 'ANDROID' | 'IOS' | 'ROUTENPLANER' | 'VAO', routeSnapshot: RouteSnapshotToStore, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return RoutesApiFp(this.configuration).saveRouteSnapshot(routeId, application, routeSnapshot, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} routeId Route Id
     * @param {UserRoute} userRoute 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    public updateRoute(routeId: string, userRoute: UserRoute, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return RoutesApiFp(this.configuration).updateRoute(routeId, userRoute, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SearchHistoryApi - axios parameter creator
 * @export
 */
export const SearchHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add search history element as last stored
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {SearchHistoryElement} searchHistoryElement 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSearchHistoryElement: async (searchHistoryType: 'ADDRESS', searchHistoryElement: SearchHistoryElement, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchHistoryType' is not null or undefined
            if (searchHistoryType === null || searchHistoryType === undefined) {
                throw new RequiredError('searchHistoryType','Required parameter searchHistoryType was null or undefined when calling addSearchHistoryElement.');
            }
            // verify required parameter 'searchHistoryElement' is not null or undefined
            if (searchHistoryElement === null || searchHistoryElement === undefined) {
                throw new RequiredError('searchHistoryElement','Required parameter searchHistoryElement was null or undefined when calling addSearchHistoryElement.');
            }
            const localVarPath = `/search-history/{searchHistoryType}`
                .replace(`{${"searchHistoryType"}}`, encodeURIComponent(String(searchHistoryType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof searchHistoryElement !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(searchHistoryElement !== undefined ? searchHistoryElement : {}) : (searchHistoryElement || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last search history elements in order of last storage
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchHistory: async (searchHistoryType: 'ADDRESS', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchHistoryType' is not null or undefined
            if (searchHistoryType === null || searchHistoryType === undefined) {
                throw new RequiredError('searchHistoryType','Required parameter searchHistoryType was null or undefined when calling getSearchHistory.');
            }
            const localVarPath = `/search-history/{searchHistoryType}`
                .replace(`{${"searchHistoryType"}}`, encodeURIComponent(String(searchHistoryType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove search history element from history
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {SearchHistoryElement} searchHistoryElement 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSearchHistoryElement: async (searchHistoryType: 'ADDRESS', searchHistoryElement: SearchHistoryElement, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchHistoryType' is not null or undefined
            if (searchHistoryType === null || searchHistoryType === undefined) {
                throw new RequiredError('searchHistoryType','Required parameter searchHistoryType was null or undefined when calling removeSearchHistoryElement.');
            }
            // verify required parameter 'searchHistoryElement' is not null or undefined
            if (searchHistoryElement === null || searchHistoryElement === undefined) {
                throw new RequiredError('searchHistoryElement','Required parameter searchHistoryElement was null or undefined when calling removeSearchHistoryElement.');
            }
            const localVarPath = `/search-history/{searchHistoryType}`
                .replace(`{${"searchHistoryType"}}`, encodeURIComponent(String(searchHistoryType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof searchHistoryElement !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(searchHistoryElement !== undefined ? searchHistoryElement : {}) : (searchHistoryElement || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchHistoryApi - functional programming interface
 * @export
 */
export const SearchHistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add search history element as last stored
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {SearchHistoryElement} searchHistoryElement 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSearchHistoryElement(searchHistoryType: 'ADDRESS', searchHistoryElement: SearchHistoryElement, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SearchHistoryApiAxiosParamCreator(configuration).addSearchHistoryElement(searchHistoryType, searchHistoryElement, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get last search history elements in order of last storage
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchHistory(searchHistoryType: 'ADDRESS', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchHistory>> {
            const localVarAxiosArgs = await SearchHistoryApiAxiosParamCreator(configuration).getSearchHistory(searchHistoryType, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove search history element from history
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {SearchHistoryElement} searchHistoryElement 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSearchHistoryElement(searchHistoryType: 'ADDRESS', searchHistoryElement: SearchHistoryElement, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SearchHistoryApiAxiosParamCreator(configuration).removeSearchHistoryElement(searchHistoryType, searchHistoryElement, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SearchHistoryApi - factory interface
 * @export
 */
export const SearchHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add search history element as last stored
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {SearchHistoryElement} searchHistoryElement 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSearchHistoryElement(searchHistoryType: 'ADDRESS', searchHistoryElement: SearchHistoryElement, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return SearchHistoryApiFp(configuration).addSearchHistoryElement(searchHistoryType, searchHistoryElement, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get last search history elements in order of last storage
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchHistory(searchHistoryType: 'ADDRESS', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<SearchHistory> {
            return SearchHistoryApiFp(configuration).getSearchHistory(searchHistoryType, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove search history element from history
         * @param {'ADDRESS'} searchHistoryType Type of the search history entries
         * @param {SearchHistoryElement} searchHistoryElement 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSearchHistoryElement(searchHistoryType: 'ADDRESS', searchHistoryElement: SearchHistoryElement, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<void> {
            return SearchHistoryApiFp(configuration).removeSearchHistoryElement(searchHistoryType, searchHistoryElement, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchHistoryApi - object-oriented interface
 * @export
 * @class SearchHistoryApi
 * @extends {BaseAPI}
 */
export class SearchHistoryApi extends BaseAPI {
    /**
     * 
     * @summary Add search history element as last stored
     * @param {'ADDRESS'} searchHistoryType Type of the search history entries
     * @param {SearchHistoryElement} searchHistoryElement 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchHistoryApi
     */
    public addSearchHistoryElement(searchHistoryType: 'ADDRESS', searchHistoryElement: SearchHistoryElement, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return SearchHistoryApiFp(this.configuration).addSearchHistoryElement(searchHistoryType, searchHistoryElement, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get last search history elements in order of last storage
     * @param {'ADDRESS'} searchHistoryType Type of the search history entries
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchHistoryApi
     */
    public getSearchHistory(searchHistoryType: 'ADDRESS', oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return SearchHistoryApiFp(this.configuration).getSearchHistory(searchHistoryType, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove search history element from history
     * @param {'ADDRESS'} searchHistoryType Type of the search history entries
     * @param {SearchHistoryElement} searchHistoryElement 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchHistoryApi
     */
    public removeSearchHistoryElement(searchHistoryType: 'ADDRESS', searchHistoryElement: SearchHistoryElement, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return SearchHistoryApiFp(this.configuration).removeSearchHistoryElement(searchHistoryType, searchHistoryElement, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SmrApi - axios parameter creator
 * @export
 */
export const SmrApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} containerId Container Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmrContainer: async (containerId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'containerId' is not null or undefined
            if (containerId === null || containerId === undefined) {
                throw new RequiredError('containerId','Required parameter containerId was null or undefined when calling getSmrContainer.');
            }
            const localVarPath = `/smr/containers/{containerId}`
                .replace(`{${"containerId"}}`, encodeURIComponent(String(containerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmrContainers: async (oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/smr/containers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SmrContainer} smrContainer 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSmrContainer: async (smrContainer: SmrContainer, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'smrContainer' is not null or undefined
            if (smrContainer === null || smrContainer === undefined) {
                throw new RequiredError('smrContainer','Required parameter smrContainer was null or undefined when calling storeSmrContainer.');
            }
            const localVarPath = `/smr/containers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof smrContainer !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(smrContainer !== undefined ? smrContainer : {}) : (smrContainer || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} containerId Container Id
         * @param {SmrContainer} smrContainer 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSmrContainer: async (containerId: string, smrContainer: SmrContainer, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'containerId' is not null or undefined
            if (containerId === null || containerId === undefined) {
                throw new RequiredError('containerId','Required parameter containerId was null or undefined when calling updateSmrContainer.');
            }
            // verify required parameter 'smrContainer' is not null or undefined
            if (smrContainer === null || smrContainer === undefined) {
                throw new RequiredError('smrContainer','Required parameter smrContainer was null or undefined when calling updateSmrContainer.');
            }
            const localVarPath = `/smr/containers/{containerId}`
                .replace(`{${"containerId"}}`, encodeURIComponent(String(containerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityMaUsername !== undefined && oeamtcIdentityMaUsername !== null) {
                localVarHeaderParameter['oeamtc-identity-ma-username'] = String(oeamtcIdentityMaUsername);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof smrContainer !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(smrContainer !== undefined ? smrContainer : {}) : (smrContainer || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmrApi - functional programming interface
 * @export
 */
export const SmrApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} containerId Container Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmrContainer(containerId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmrContainer>> {
            const localVarAxiosArgs = await SmrApiAxiosParamCreator(configuration).getSmrContainer(containerId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmrContainers(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmrContainers>> {
            const localVarAxiosArgs = await SmrApiAxiosParamCreator(configuration).getSmrContainers(oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SmrContainer} smrContainer 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeSmrContainer(smrContainer: SmrContainer, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmrContainer>> {
            const localVarAxiosArgs = await SmrApiAxiosParamCreator(configuration).storeSmrContainer(smrContainer, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} containerId Container Id
         * @param {SmrContainer} smrContainer 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSmrContainer(containerId: string, smrContainer: SmrContainer, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmrContainer>> {
            const localVarAxiosArgs = await SmrApiAxiosParamCreator(configuration).updateSmrContainer(containerId, smrContainer, oeamtcIdentityKey, oeamtcIdentityMaUsername, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SmrApi - factory interface
 * @export
 */
export const SmrApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} containerId Container Id
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmrContainer(containerId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<SmrContainer> {
            return SmrApiFp(configuration).getSmrContainer(containerId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmrContainers(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<SmrContainers> {
            return SmrApiFp(configuration).getSmrContainers(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SmrContainer} smrContainer 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSmrContainer(smrContainer: SmrContainer, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<SmrContainer> {
            return SmrApiFp(configuration).storeSmrContainer(smrContainer, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} containerId Container Id
         * @param {SmrContainer} smrContainer 
         * @param {string} [oeamtcIdentityKey] 
         * @param {string} [oeamtcIdentityMaUsername] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSmrContainer(containerId: string, smrContainer: SmrContainer, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any): AxiosPromise<SmrContainer> {
            return SmrApiFp(configuration).updateSmrContainer(containerId, smrContainer, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SmrApi - object-oriented interface
 * @export
 * @class SmrApi
 * @extends {BaseAPI}
 */
export class SmrApi extends BaseAPI {
    /**
     * 
     * @param {string} containerId Container Id
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmrApi
     */
    public getSmrContainer(containerId: string, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return SmrApiFp(this.configuration).getSmrContainer(containerId, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmrApi
     */
    public getSmrContainers(oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return SmrApiFp(this.configuration).getSmrContainers(oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SmrContainer} smrContainer 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmrApi
     */
    public storeSmrContainer(smrContainer: SmrContainer, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return SmrApiFp(this.configuration).storeSmrContainer(smrContainer, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} containerId Container Id
     * @param {SmrContainer} smrContainer 
     * @param {string} [oeamtcIdentityKey] 
     * @param {string} [oeamtcIdentityMaUsername] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmrApi
     */
    public updateSmrContainer(containerId: string, smrContainer: SmrContainer, oeamtcIdentityKey?: string, oeamtcIdentityMaUsername?: string, options?: any) {
        return SmrApiFp(this.configuration).updateSmrContainer(containerId, smrContainer, oeamtcIdentityKey, oeamtcIdentityMaUsername, options).then((request) => request(this.axios, this.basePath));
    }

}


